<sp-admin-data-import-request-export-diff
    [importRequest]="importRequest$ | async"
    (confirm)="onExportDiffYearSelected($event)">
</sp-admin-data-import-request-export-diff>

<sp-admin-data-import-request-import
    *ngIf="(importRequest$ | async)"
    [importRequest]="(importRequest$ | async)"
    (uploading)="onUploading()"
    (uploaded)="onUploaded($event)">
</sp-admin-data-import-request-import>
<section>
    <header class="row page-header">

        <div class="col-sm-12">

            <sp-breadcrumbs>
                <sp-breadcrumb [text]="'Admin'" [routerLink]="'../../'"></sp-breadcrumb>
                <sp-breadcrumb [text]="'Data Import Requests'" [routerLink]="'../'"></sp-breadcrumb>
            </sp-breadcrumbs>

            <div class="row">
                <div class="col-sm-6">
                    <a class="btn-back" [routerLink]="['../']"></a>
                    <h2 class="title">Import Request Details</h2>
                </div>
                <div class="col-sm-6 text-end">
                    <div class="controls">
                        <ng-container *ngIf="(importRequest$ | async)?.includesPropertyComponentIds; else preview">

                            <ng-container *ngIf="(importRequest$ | async)?.fiscalYears?.length === 1; else selectYear">
                                <button class="btn btn-link" (click)="onExportDiff()">
                                    <i class="fa-regular fa-file-excel" aria-hidden="true"></i> Export (Compare/Diff)
                                </button>
                            </ng-container>
                            <ng-template #selectYear>
                                <button class="btn btn-link" (click)="exportDiff.show()">
                                    <i class="fa-regular fa-file-excel" aria-hidden="true"></i> Export (Compare/Diff)
                                </button>
                            </ng-template>

                            <button class="btn btn-link" (click)="importComponent.show()">
                                <i class="fa fa-cloud-upload" aria-hidden="true"></i> Import
                            </button>
                        </ng-container>
                        <ng-template #preview>
                            <button class="btn btn-link" (click)="onExportDiff()">
                                <i class="fa-regular fa-file-excel" aria-hidden="true"></i> Preview Data Import
                            </button>
                        </ng-template>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <div class="row">
        <div class="col-sm-12 comm-state">
            <div style="margin:10px auto;">
                <sp-comm-state [successMessage]="(('Components' | terminology | async) || 'Components') + ' imported successfully'" [failedMessage]="(('Component' | terminology | async) || 'Component') + ' import failed'" #uploadState></sp-comm-state>
            </div>
        </div>
    </div>

    <main>
        <sp-admin-import-request-details
            *ngIf="importRequest$ | async"
            [importRequest]="importRequest$ | async"
            (exportDiff)="onExportDiff()"
            (exportDiffSelectYear)="exportDiff.show()"
            (import)="importComponent.show()"
            (submit)="onSubmit($event)">
        </sp-admin-import-request-details>
    </main>
</section>
